<script setup>
import {couponConf} from "@/utils/config";
import {computed, defineProps, ref} from "vue";
import router from "@/router";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf['hibake-scal'];
    }
  }
});
const coupon = computed(() => {
  return props.couponLst?.[0]?.data || []
})
const recharge_content = ref("001")
</script>

<template>
  <div class="hi-bake-product">
    <div class="hi-bake-product-title">
      <el-image src="https://images.jifen360.com/hibake/hibake-title.png"/>
    </div>
    <el-row>
      <el-col :span="12" v-for="(item, index) in coupon" :key="index" style="box-sizing: border-box;padding: 5px">
        <div class="hi-bake-product-item">
          <el-image :src="item.img" @click="router.push({name:'detail',params:{id:item.id}})"/>
          <div class="hi-bake-product-info">
            <h5 class="hi-bake-product-name" @click="router.push({name:'detail',params:{id:item.id}})">{{ item.name }}</h5>
            <div class="hi-bake-product-price" @click="router.push({name:'detail',params:{id:item.id}})">
                <el-text class="hi-bake-product-score-value"><b>{{ item?.score_data?.[type.login]?.total }}</b></el-text>
                <el-text class="hi-bake-product-score-unit">{{ item?.score_data?.[type.login]?.unit }}</el-text>
              <el-text type="info" class="hi-bake-product-money">￥{{ item?.face_value }}</el-text>
            </div>
            <el-button round class="recharge-btn" size="large" @click="router.push({name:'detail',params:{id:item.id},query:{pay:true}})">
              立即兑换
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>

  <div class="hi-bake-recharge-content">
    <div class="hi-bake-recharge-content-title">
      <div class="hi-bake-recharge-content-title-001" @click="recharge_content='001'"></div>
      <div class="hi-bake-recharge-content-title-001" @click="recharge_content='002'"></div>
      <el-image :src="`https://images.jifen360.com/hibake/${recharge_content}.png`"/>
    </div>
    <div class="hi-bake-recharge-content-body">
      <div v-if="recharge_content==='001'">
        <ol>
          <li>里程兑换商品不提供报销凭证，兑换成功不可退换、转售、兑现、找零、拆分使用；</li>
          <li>商品兑换成功后，“电子兑换码”将以短信的形式发送至兑换时填写的手机号，<el-text type="danger">请确保兑换时手机号填写正确</el-text>，因手机号码填写错误造成的损失由会员本人承担；</li>
          <li>本券有效期：短信获取的“电子兑换码”需在<el-text type="danger">2025年8月30日前</el-text>在“Hibake烘焙”微信小程序内兑换成产品券，产品券自兑换之日起在“Hibake烘焙”微信小程序<el-text type="danger">30天内有效</el-text>，过期作废，不退不补；</li>
          <li>如需帮助，请拨打服务热线：4000-360-195。</li>
        </ol>
        <h4 style="margin: 15px auto">使用方法</h4>
        <ol>
          <li>使用方法：<el-text type="danger">点开短信内链接</el-text>复制“电子兑换码” →微信搜索“Hibake烘焙” 小程序→点击【我的】→点击【优惠券】→输入复制的【电子兑换码】→点击“兑换”；</li>
          <li>适用场景：本券仅支持在【Hibake烘焙】小程序下单使用，可转赠、可叠加多张使用。<el-text type="danger">可用门店详情请见【Hibake烘焙】小程序内适用门店；</el-text></li>
          <li>到店使用：点击优惠券列表内对应卡券【立即使用】，出示给门店工作人员核销成功后换取对应产品；</li>
          <li>使用规则：本券为指定产品券，仅支持到店自提，不与门店其他优惠券/优惠活动同享；</li>
          <li>为确保本活动的合规、有序开展，如用户/商户出现违规行为(如虚假交易、恶意套利等)，Hibake有权冻结其用户账号，并有权取消或收回其因参加本活动所获的回馈和奖励；</li>
          <li>本平台仅是提供会员与商户的兑换服务平台，如遇商品质量问题，请及时与商家联系。</li>
        </ol>
      </div>
      <el-image v-if="recharge_content==='002'" src="https://images.jifen360.com/hibake/step.png"/>
    </div>
  </div>
</template>

<style scoped lang="less">
.hi-bake-product {
  margin: 15px;
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px;

  .hi-bake-product-item {
    box-sizing: border-box;
    padding: 10px;
    //background: #666;
    border: var(--el-border);
    border-radius: 5px;

    .hi-bake-product-info {
      text-align: center;
      line-height: 1.7;

      .hi-bake-product-name {
        //font-size: 12px;
        color: #333;
      }

      .hi-bake-product-price{

        .hi-bake-product-score-value{
          color: #E1AF74;
          font-size: 1.45rem;
        }

        .hi-bake-product-score-unit{
          padding-right: 8px;
        }
        .hi-bake-product-money{
          //删除线
          text-decoration: line-through;
        }
      }

      .recharge-btn{
        //渐变背景
        background: linear-gradient(to bottom, #c8b29f, #a67a55);
        color: #ffffff;
        width: 100%;
      }
    }
  }
}

.hi-bake-recharge-content{
  //background: #ffffff;
  margin: 15px;

  .hi-bake-recharge-content-title{
    position: relative;
    display: flex;
    align-content: center;
    justify-content: space-between;
    height: 60px;

    .hi-bake-recharge-content-title-001{
      //background: #ffffff;
      height: 60px;
      flex-basis: 50%;
      position: relative;
      z-index: 99;
    }

    .el-image{
      position: absolute;
      left: 0;
      right: 0;
      z-index: 0;
    }
  }

  .hi-bake-recharge-content-body{
    background: #ffffff;
    border-radius: 0 0 12px 12px;
    margin-top: -10px;
    box-sizing: border-box;
    padding: 15px;
    ol{
      padding-left: 15px;
      line-height: 1.5;
      font-size: .8rem;
      text-align: justify;

      .el-text{
        font-size: .8rem;
      }
    }

    .el-image{
      padding: 10px;
      background: #F7F0E6;
      border-radius: 8px;
    }
  }
}
</style>
